/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';
import FAQBlock from 'app/components/Subscription/FAQBlock.jsx';
import { Breakpoint } from 'react-socks';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import SupportedNetworks from 'app/components/Subscription/SupportedNetworks.jsx';
import AddOnWidget from 'app/components/Subscription/AddOnWidget.jsx';

class PricingMatrix extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedRow: -1,
            selectedTerm: 1,
            addOnQuantity: {}
        };

        this.goBack = this.goBack.bind(this);
        this.signUp = this.signUp.bind(this);
        this.toggleFeature = this.toggleFeature.bind(this);
        this.matrixAction = this.matrixAction.bind(this);
        this.goToPlan = this.goToPlan.bind(this);
        this.recordPlanSelection = this.recordPlanSelection.bind(this);
        this.generateFeatureDescription = this.generateFeatureDescription.bind(this);
        this.generateFeatureList = this.generateFeatureList.bind(this);
        this.generatePlanColumn = this.generatePlanColumn.bind(this);
        this.generateAgencyBlock = this.generateAgencyBlock.bind(this);
        this.generateMobileFeatureList = this.generateMobileFeatureList.bind(this);
        this.togglePricing = this.togglePricing.bind(this);
        this.updateAddOnQuantity = this.updateAddOnQuantity.bind(this);
        this.generateAddOnWidgetLabel = this.generateAddOnWidgetLabel.bind(this);

    }

    componentDidMount() {
        let constants = this.props.app.config.constants;

        if (this.props.context !== 'public') {
            if (dataLayer) {
        		dataLayer.push({
        			'event': 'anchor-pageview',
        			'virtualURL': '/vp/account/subscription/compare'
        		});
            }
        }

        let defaultAddOns = {};
        defaultAddOns[constants.PUB_LEVEL_6] = 0;
        defaultAddOns[constants.PUB_LEVEL_9] = 0;

        this.setState({
            addOnQuantity: defaultAddOns
        });
    }

    goBack() {

        if (this.props.context === 'upgrade') {
            this.props.router.navigate('/account/subscription');
        } else {
            this.props.router.navigate('/account/subscription/new');
        }
    }

    signUp() {

        window.parent.location.href = this.props.app.config.appUrl + "/login/new";

    }

    toggleFeature(e) {

        let row = parseInt(e.currentTarget.dataset.row, 10),
            newRow = row;

        if (row === this.state.selectedRow) {
            newRow = -1;
        }

        this.setState({
            selectedRow: newRow
        });

    }

    // The matrix is the only plan picker that isn't on /account/subscription/new, so
    // without this its selections never reach the checkout funnel. Mirrors the payload
    // SubscriptionNew.startUpgrade sends; `source` is what tells the two apart.
    recordPlanSelection(planCode, source) {

        // the public marketing bundle has no recordEvent bridge and no user
        if (!this.props.recordEvent || this.props.context === 'public') {
            return;
        }

        let constants = this.props.app.config.constants,
            term = (this.state.selectedTerm === constants.SUBSCRIPTION_TERM_ANNUAL) ? ' Annual' : ' Monthly',
            planDetail = this.props.plans ? this.props.plans[planCode] : null;

        this.props.recordEvent({
            pub_id: this.props.user.detail.id,
            event_name: 'Start Checkout',
            event_data: {
                plan: ((planDetail && planDetail.label) ? planDetail.label : planCode) + term,
                source
            }
        });
    }

    matrixAction(e) {
        let subscriptionUrl = '';

        this.recordPlanSelection(e.currentTarget.dataset.plan, 'compare-matrix');

        // the public bundle has no router: sign-up is a page of its own
        if (this.props.context === 'public') {
            this.signUp();
            return;
        }

        if (!this.props.isFreeUser() && !this.props.isTrialUser()) {
           subscriptionUrl = `/account/subscription/change?plan=${e.currentTarget.dataset.plan}`;
        } else {
            subscriptionUrl = `/account/subscription/new?plan=${e.currentTarget.dataset.plan}`;
        }

        if (this.state.selectedTerm !== 1) {
            subscriptionUrl += `&term=${this.state.selectedTerm}`;
        }
        if (this.state.addOnQuantity[e.currentTarget.dataset.plan]) {
            subscriptionUrl += `&addons=${this.state.addOnQuantity[e.currentTarget.dataset.plan]}`;
        }
        this.props.router.navigate(subscriptionUrl);

    }

    goToPlan(e) {
        let plan = e.currentTarget.dataset.plan;
        //this.props.closePlanChangeBlock();

        this.recordPlanSelection(plan, 'compare-matrix');

        let subscriptionUrl = `/account/subscription/change?plan=${plan}`
        if (this.state.selectedTerm !== 1) {
            subscriptionUrl += `&term=${this.state.selectedTerm}`;
        }
        if (this.state.addOnQuantity[e.currentTarget.dataset.plan]) {
            subscriptionUrl += `&addons=${this.state.addOnQuantity[e.currentTarget.dataset.plan]}`;
        }

        this.props.router.navigate(subscriptionUrl);
    }

    generateFeatureDescription(i, feature) {
        let className = (this.state.selectedRow === i) ? ' expanded': '',
            clickHandler = (feature.expanded !== '') ? this.toggleFeature : null,
            expandHint = null;

        if (feature.expanded !== '') {
            if (this.state.selectedRow === i) {
                expandHint = (<span className="key-expand-marker" aria-hidden="true"><i className="icon ion-ios-arrow-down"></i></span>);
            } else {
                expandHint = (<span className="key-expand-marker" aria-hidden="true"><i className="icon ion-ios-arrow-forward"></i></span>);
            }
        }

        if (feature.divider) {
            <li key={i} className="section-divider">
                <div className="key-feature-title"></div>
            </li>
        }

        if (feature.sectionTitle) {
            className += " section-title";
        }

        if (feature.borderless) {
            className += " borderless";
        }

        if (clickHandler === null) {
            className += ' no-pointer';
        }

        if (feature.name.match("Social Profile")) {
            className += ' socials';
        }

        let name = feature.footnote ? `${feature.name} ${feature.footnote}` : feature.name,
            title = (
                <div className="key-feature-title">
                    {name}
                </div>
            );

        if (clickHandler !== null) {
            // the row's click does the toggling; the button is how a keyboard reaches it, and says if it's open
            title = (
                <button type="button" className="key-feature-title" aria-expanded={this.state.selectedRow === i}>
                    {name} {expandHint}
                </button>
            );
        }

        return (
            <li key={i} className={className} onClick={clickHandler} data-row={i}>
                {title}
                <div className="key-feature-desc">
                    {feature.expanded}
                </div>
            </li>
        );
    }

    generateFeatureList(i, feature, plan) {
        let className = '',
            clickHandler = null,
            content = null;

        if (feature.divider) {
            return (
                <li key={i} className="section-divider-feature borderless"></li>
            );
        }

        className = (this.state.selectedRow === i) ? feature.class[plan] + ' expanded' : feature.class[plan];
        clickHandler = (feature.expanded !== '') ? this.toggleFeature : null;

        if (feature.borderless !== undefined && feature.borderless) {
            className += " borderless";
        }

        if (clickHandler === null) {
            className += ' no-pointer';
        }

        if (_.isNumber(feature[plan])) {
            content = feature[plan];
        } else if (_.isBoolean(feature[plan])) {
            className += ' matrix-check';
            if (feature[plan]) {
                content = (
                    <i className="icon ion-ios-checkmark-outline" role="img" aria-label="Included"></i>
                );
            } else {
                content = "\u00a0";
            }
        } else {
            content = feature[plan];
        }


        return (
            <li key={i} className={className} onClick={clickHandler} data-row={i}>
                {content}
            </li>
        );
    }

    generateMobileFeatureList(i, feature, plan) {
        let className = '',
            clickHandler = null,
            content = null,
            mobileFeature = null;

        if (feature.divider && plan === 'proplus') {
            return (
                <li key={i} className="section-divider-feature borderless"></li>
            );
        } else if (feature.divider) {
            return null;
        }

        className = (this.state.selectedRow === i) ? feature.class[plan] + ' expanded' : feature.class[plan];
        clickHandler = (feature.expanded !== '') ? this.toggleFeature : null;

        if (feature.borderless !== undefined && feature.borderless) {
            className += " borderless";
        }

        if (clickHandler === null) {
            className += ' no-pointer';
        }

        let footnote = feature.footnote ? ` ${feature.footnote}` : '';

        if (_.isNumber(feature[plan])) {
            content = (
                <span>{feature.name}: {feature[plan]}{footnote}</span>
            );
        } else if (_.isBoolean(feature[plan])) {
            className += ' matrix-check';
            if (feature[plan]) {
                content = (
                    <span>{feature.name} <i className="icon ion-ios-checkmark-outline" role="img" aria-label="Included"></i></span>
                );
            }
        } else {
            if (feature[plan] !== "-") {
                if (!feature.prices && feature.name) {
                    content = (
                        <span>{feature.name}: {feature[plan]}{footnote}</span>
                    );
                } else if (!feature.prices) {
                    content = (
                        <span>{feature[plan]}</span>
                    );
                } else {
                    content = (
                        feature[plan]
                    );
                }
            }
        }

        if ((feature.sectionTitle && plan !== 'proplus') || content === null) {
            return null;
        }

        return (
            <li key={i} className={className} data-row={i}>
                <div className="mobile-feature">
                    {content}
                </div>
            </li>
        );
    }


    generatePlanColumn(i, plan, features) {
        let planStyle = 'plan-column ' + plan,
            buttonStyle = 'matrix-button ' + plan,
            planLabel = 'Your Current Plan',
            planAction = this.matrixAction,
            planCode = 1,
            constants = this.props.app.config.constants,
            planSticker = null,
            generateSticker = function() {
                return (
                    <div className={"plan-sticker " + plan}>
                        <span>Most Popular</span>
                    </div>
                );
            };

        if (this.props.context === 'public') {
            planLabel = "Get Started";
        } else {
            switch (plan) {
                case 'launch':
                    planLabel = null;
                    break;

                case 'proplus':
                    planCode = constants.PUB_LEVEL_9;
                    if (this.props.isTrialUser() || this.props.isFreeUser()) {
                        planLabel = "Get Plus";
                    } else if (this.props.isProUser(this.props.user.detail.pubLevel)) {
                        planLabel = "Upgrade to Plus";
                    } else if (!this.props.isPlusUser(this.props.user.detail.pubLevel)) {
                        planLabel = "Change Your Plan";
                        buttonStyle += " reverse";
                    } else {
                        planAction = this.goToPlan;
                    }
                    break;

                case 'pro':
                    planCode = constants.PUB_LEVEL_6;
                    if (this.props.isFreeUser(this.props.user.detail.pubLevel) || this.props.isTrialUser(this.props.user.detail.pubLevel)) {
                        planLabel = "Get Pro";
                    } else if (!this.props.isProUser(this.props.user.detail.pubLevel)) {
                        planLabel = "Change Your Plan";
                        buttonStyle += " reverse";
                    } else {
                        planAction = this.goToPlan;
                    }
                    break;

                default:
                    planAction = this.goToPlan;
                    buttonStyle += " reverse";
                    break;
            }
        }

        if (plan === 'pro') {
            if (this.props.context) {
                planSticker = generateSticker();
            }
        }

        let planDisplayLabel = plan;
        if (plan === 'proplus') {
            planDisplayLabel = planDisplayLabel.replace('proplus', 'Plus');
        }
        if (plan === 'launch') {
            planDisplayLabel = planDisplayLabel.replace('launch', 'Free');
        }

        return (
            <div className={planStyle} key={i} data-pw={`plan-${plan}`}>
                {planSticker}
                <div className="plan-header">
                    {planDisplayLabel}
                </div>
                <div className="plan-list-container">
                    <Breakpoint desktop only>
                        <ul className="plan-list">
                            {features.map((feature, i) => {
                                return this.generateFeatureList(i, feature, plan);
                            })}
                        </ul>
                    </Breakpoint>
                    <Breakpoint mobile only>
                        <ul className="plan-list">
                            {features.map((feature, i) => {
                                return this.generateMobileFeatureList(i, feature, plan);
                            })}
                        </ul>
                    </Breakpoint>
                </div>
                <div className="plan-action">
                    {planLabel ? (
                        <button className={buttonStyle} onClick={planAction} data-plan={planCode}>
                            {planLabel}
                        </button>
                    ) : null}
                </div>
            </div>
        );
    }

    generateAgencyBlock() {
        let planLabel = "Your Current Plan",
            planAction = this.matrixAction,
            planCode = 8,
            buttonStyle = "matrix-button agency",
            constants = this.props.app.config.constants;

            if (this.props.context === 'public') {
                planLabel = "Get Started";
            } else {
                if (this.props.isFreeUser()) {
                    planLabel = "Get Agency";
                } else if (!this.props.isAgencyUser(this.props.user.detail.pubLevel)) {
                    planLabel = "Upgrade to Agency";
                } else {
                    buttonStyle += " reverse";
                    planAction = this.goToPlan;
                }
            }

        let price = this.props.plans[constants.PUB_LEVEL_8].price[this.state.selectedTerm];

        if (this.state.selectedTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
            price = price / 12;
        }
        price = price.toFixed(2);

        return (
            <div className="plan-display">
                <h3>Agency? We've got you covered.</h3>
                <div className="agency-block">
                    <div className="agency-header">Agency Plan</div>
                    <div className="agency-features">
                        <h2>For ${price}/mo you'll get all of the features of Pro and</h2>
                        <ul className="agency-feature-list">
                            <li>
                                <div className="feature-quantity">
                                    250
                                </div>
                                <div className="feature-desc">
                                    <Breakpoint desktop only>
                                        Social Profiles<br/>& Pages
                                    </Breakpoint>
                                    <Breakpoint mobile only>
                                        Social Profiles & Pages
                                    </Breakpoint>
                                </div>
                            </li>
                            <li>
                                <div className="feature-quantity">
                                    1500
                                </div>
                                <div className="feature-desc">
                                    <Breakpoint desktop only>
                                        Inputs
                                    </Breakpoint>
                                    <Breakpoint mobile only>
                                        Inputs
                                    </Breakpoint>
                                </div>
                            </li>
                            <li>
                                <div className="feature-quantity">
                                    2 Minute
                                </div>
                                <div className="feature-desc">
                                    <Breakpoint desktop only>
                                        Feed<br/>Updates
                                    </Breakpoint>
                                    <Breakpoint mobile only>
                                        Feed Updates
                                    </Breakpoint>
                                </div>
                            </li>
                            <li>
                                <div className="feature-quantity">
                                    10
                                </div>
                                <div className="feature-desc">
                                    <Breakpoint desktop only>
                                        Team<br/>Members
                                    </Breakpoint>
                                    <Breakpoint mobile only>
                                        Team Members
                                    </Breakpoint>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="plan-action">
                        <button className={buttonStyle} onClick={planAction} data-plan={planCode}>
                            {planLabel}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    togglePricing(e) {
        let nextTerm = e.currentTarget.dataset.togglestate === 'true' ? 1 : 2;

        this.setState({
            selectedTerm: nextTerm
        });

    }

    updateAddOnQuantity(plan, quantity) {
        let nextAddOnQuantity = Object.assign({}, this.state.addOnQuantity);

        nextAddOnQuantity[plan] = quantity;

        this.setState({
            addOnQuantity: nextAddOnQuantity
        });
    }

    generateAddOnWidgetLabel(plan, quantity) {
        let constants = this.props.app.config.constants,
            planQuantity = 0,
            baseQuantity = 0;

        if (!_.isEmpty(this.props.plans)) {
            baseQuantity = parseInt(this.props.plans[plan].limits.hardLimitOutputs);
            planQuantity = this.props.plans[plan].addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS].socials
            return baseQuantity + (quantity * planQuantity);
        }

        return '';
    }

    generateDisplayPrice(plan) {
        let constants = this.props.app.config.constants;

        if (!_.isEmpty(this.props.plans)) {
            let planPrice = this.props.plans[plan].price[this.state.selectedTerm],
                addOnPrice = this.props.plans[plan].addOnPrices[constants.SUBSCRIPTION_ADDON_SOCIALS][this.state.selectedTerm],
                planTotal = planPrice;

            if (this.state.addOnQuantity[plan] !== undefined) {
                planTotal += addOnPrice * this.state.addOnQuantity[plan];
            }

            if (this.state.selectedTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
                planTotal = planTotal / 12;
            }

            return `$${planTotal.toFixed(2)}`
        }

        return '';
    }

    render() {
        let constants = this.props.app.config.constants,
            wrapperClass = 'pricing-matrix-wrapper',
            launchPricing = (
                <div className="pricing-block">
                    <div className="price launch">Free</div>
                    <div className="price-savings">{'\u00A0'}</div>
                    <div className="price-copy">Simple, reliable automation for your core profiles.</div>
                </div>
            ),
            proPricing = (
                <div className="pricing-block">
                    <div className="price pro">{this.generateDisplayPrice(constants.PUB_LEVEL_6)} / mo</div>
                    <div className="price-savings">{'\u2014 Billed Annually \u2014'}</div>
                    <div className="price-copy">Essential social media automation for businesses and established professionals.</div>
                </div>
            ),
            plusPricing = (
                <div className="pricing-block">
                    <div className="price proplus">{this.generateDisplayPrice(constants.PUB_LEVEL_9)} / mo</div>
                    <div className="price-savings">{'\u2014 Billed Annually \u2014'}</div>
                    <div className="price-copy">Our most powerful social automation tools. For social media power users.</div>
                </div>
            ),
            features = [
                {
                    'name': '',
                    'launch': launchPricing,
                    'pro': proPricing,
                    'proplus': plusPricing,
                    'expanded': '',
                    'class': {
                        'launch':'launch-price',
                        'pro': 'pro-price',
                        'proplus': 'proplus-price'
                    },
                    prices: true
                },
                {
                    'name': 'Social Profiles & Pages',
                    'launch': 3,
                    'pro': <AddOnWidget
                                plan={constants.PUB_LEVEL_6}
                                term={this.state.selectedTerm}
                                onQuantityChange={this.updateAddOnQuantity}
                                labelMaker={this.generateAddOnWidgetLabel}/>,
                    'proplus': <AddOnWidget
                                    plan={constants.PUB_LEVEL_9}
                                    term={this.state.selectedTerm}
                                    onQuantityChange={this.updateAddOnQuantity}
                                    labelMaker={this.generateAddOnWidgetLabel}/>,
                    'expanded': 'Connect your Facebook pages, X (Twitter), and other social profiles to keep them up to date with your freshest content.',
                    'class': {
                        'launch':'feature-bold socials',
                        'pro': 'feature-bold socials',
                        'proplus': 'feature-bold socials'
                    },
                    borderless: true,
                },
                {
                    'name': '',
                    'launch': 'Per Network',
                    'pro': 'Any combination',
                    'proplus': 'Any combination',
                    'expanded': '',
                    'class': {
                        'launch':'',
                        'pro': '',
                        'proplus': ''
                    }
                },
                {
                    'name': 'Monthly Posts',
                    'footnote': '*',
                    'launch': '10',
                    'pro': 'Unlimited',
                    'proplus': 'Unlimited',
                    'expanded': 'Unlock posting limits for essential social profiles.',
                    'class': {
                        'launch':'feature-bold',
                        'proplus': 'feature-bold',
                        'pro': 'feature-bold'
                    }
                },
                {
                    'name': 'Inputs',
                    'launch': 3,
                    'pro': 50,
                    'proplus': 75,
                    'expanded': 'Quickly and efficiently share content to your social profiles with RSS feeds.',
                    'class': {
                        'launch':'feature-bold',
                        'proplus': 'feature-bold',
                        'pro': 'feature-bold'
                    }
                },
                {
                    'name': 'Queued Items',
                    'launch': '10 / social',
                    'pro': '150 / social',
                    'proplus': '500 / social',
                    'expanded': "Fill your queue with items and we'll automatically share them on your daily posting schedule.",
                    'class': {
                        'launch':'',
                        'proplus': '',
                        'pro': ''
                    }
                },
                {
                    'name': 'Feed Updates',
                    'launch': '6 hour',
                    'pro': '5 minutes',
                    'proplus': '5 minutes',
                    'expanded': 'Distribute new content to your socials almost as fast as you can post it on your site.',
                    'class': {
                        'launch':'',
                        'pro': '',
                        'proplus': ''
                    }
                },
                {
                    'name': 'Calendar',
                    'launch': true,
                    'pro': true,
                    'proplus': true,
                    'expanded': "Easily plan your social media posting.",
                    'class': {
                        'launch':'',
                        'pro': '',
                        'proplus': ''
                    },
                },
                {
                    'name': 'Team Members',
                    'launch': '-',
                    'pro': 2,
                    'proplus': 3,
                    'expanded': 'Share the work accross your team with muiltiple access logins to your dlvr.it account.',
                    'class': {
                        'launch': '',
                        'pro': '',
                        'proplus': ''
                    },
                    borderless: true
                },
                // {
                //     'name': 'Content Curation',
                //     'basic': true,
                //     'pro': true,
                //     'proplus': true,
                //     'expanded': 'Hand-select items from your feeds to share across your social networks.',
                //     'class': {
                //         'basic': '',
                //         'pro': '',
                //         'proplus': ''
                //     }
                // },
                // {
                //     'name': 'Stats and Insights',
                //     'basic': true,
                //     'pro': true,
                //     'proplus': true,
                //     'expanded': 'See your social media engagement stats all in one place and watch how individual posts perform on each social page.',
                //     'class': {
                //         'basic':'',
                //         'pro': '',
                //         'proplus': ''
                //     }
                // },
                // {
                //     'name': 'Link Shortener',
                //     'basic': true,
                //     'pro': true,
                //     'proplus': true,
                //     'expanded': 'Automatically post shortened links with dlvr.it, bit.ly, or your favorite link shortening service.',
                //     'class': {
                //         'basic':'',
                //         'pro': '',
                //         'proplus': ''
                //     }
                // },
                // {
                //     'name': 'Post to Pinterest',
                //     'basic': '-',
                //     'pro': true,
                //     'proplus': true,
                //     'expanded': 'Share beautiful images to Pinterest from RSS feeds.',
                //     'class': {
                //         'basic': '',
                //         'pro': '',
                //         'proplus': ''
                //     }
                // },
                // {
                //     'name': 'Twitter Inputs',
                //     'basic': '-',
                //     'pro': true,
                //     'agency': true,
                //     'expanded': 'Automatically repost and retweet items from Twitter across your social networks.',
                //     'class': {
                //         'basic':'',
                //         'pro': '',
                //         'agency': ''
                //     }
                // },
                // {
                //     'name': 'RSS Feed Outputs',
                //     'basic': '-',
                //     'pro': true,
                //     'proplus': true,
                //     'expanded': 'Build your own custom RSS feed with content you select.',
                //     'class': {
                //         'basic':'',
                //         'pro': '',
                //         'proplus': ''
                //     }
                // },
                {
                    'name': '',
                    'divider': true,
                    'expanded': '',
                    'borderless': true
                },
                {
                    'name': 'Social Media Power Tools',
                    'launch': '',
                    'pro': '',
                    'proplus': '',
                    'expanded': "",
                    'class': {
                        'launch':'',
                        'pro': '',
                        'proplus': ''
                    },
                    'sectionTitle': true
                },
                {
                    'name': 'Smart Hashtags',
                    'launch': '-',
                    'pro': '-',
                    'proplus': true,
                    'expanded': 'Our AI powered Smart Hashtags analyze your content and automatically add relevant hashtags to your posts.',
                    'class': {
                        'launch':'',
                        'pro': '',
                        'proplus': 'blue'
                    }
                },
                {
                    'name': 'Dynamic #hashtag Pool',
                    'launch': '-',
                    'pro': '-',
                    'proplus': true,
                    'expanded': 'Automatically cycle through a pool of related #hashtags to keep your posts fresh and engaging.',
                    'class': {
                        'launch':'',
                        'pro': '',
                        'proplus': 'blue'
                    }
                },
                {
                    'name': 'Auto Recycle Posts',
                    'launch': '-',
                    'pro': '-',
                    'proplus': true,
                    'expanded': "Introducing EverQueue. Automatically recycle your social media posts. Never let your social media queue run dry.",
                    'class': {
                        'launch':'',
                        'pro': '',
                        'proplus': 'blue'
                    }
                },
                {
                    'name': 'Bulk Scheduler',
                    'launch': '-',
                    'pro': '-',
                    'proplus': true,
                    'expanded': "Schedule weeks worth of social media posts with just a few clicks.",
                    'class': {
                        'launch':'',
                        'pro': '',
                        'proplus': 'blue'
                    }
                },
                {
                    'name': 'CSV Scheduler',
                    'launch': '-',
                    'pro': '-',
                    'proplus': true,
                    'expanded': "Instantly fill your social media posting schedule with your best articles, links and photos.",
                    'class': {
                        'launch':'',
                        'pro': '',
                        'proplus': 'blue'
                    }
                },
                {
                    'name': 'Category Manager',
                    'launch': '-',
                    'pro': '-',
                    'proplus': true,
                    'expanded': "Easily manage your different content types. Create custom content categories, each with its own posting schedule.",
                    'class': {
                        'launch':'',
                        'pro': '',
                        'proplus': 'blue'
                    }
                },
                {
                    'name': 'WordPress Scheduler',
                    'launch': '-',
                    'pro': '-',
                    'proplus': true,
                    'expanded': "Import and schedule your top blog posts for sharing and resharing on social media.",
                    'class': {
                        'launch':'',
                        'pro': '',
                        'proplus': 'blue'
                    }
                }

            ],
            plans = ['launch', 'pro', 'proplus'],
            faqBlock = null,
            matrixHeaderClass = 'matrix-header';

        if (_.isEmpty(this.props.plans) || _.isEmpty(this.props.user)) {
            if (this.props.context !== 'public') {
                return null;
            }
        }

        if (this.props.bannerVisible) {
            wrapperClass += ' banner-adjust';
        }

        if (this.props.context === 'public') {
            wrapperClass = '';
        }

        if (this.props.context !== "public") {
            faqBlock = (
                <div className="matrix-faq-wrapper">
                    <FAQBlock {...this.props} />
                    <div className="matrix-support-block">
                        <a href="https://support.dlvrit.com" target="_blank">We're here to help. Send us your questions.</a>
                    </div>
                </div>
            );
            matrixHeaderClass += ' app';
        }

        if (this.state.selectedTerm === 1) {
            proPricing = (
                <div className="pricing-block">
                    <div className="price pro">{this.generateDisplayPrice(constants.PUB_LEVEL_6)} / mo</div>
                    <div className="price-savings">{'\u2014 Billed Monthly \u2014'}</div>
                    <div className="price-copy">Essential social media automation for businesses and established professionals.</div>
                </div>
            );
            plusPricing = (
                <div className="pricing-block">
                    <div className="price proplus">{this.generateDisplayPrice(constants.PUB_LEVEL_9)} / mo</div>
                    <div className="price-savings">{'\u2014 Billed Monthly \u2014'}</div>
                    <div className="price-copy">Our most powerful social automation tools. For social media power users.</div>
                </div>
            );

            features[0].pro = proPricing;
            features[0].proplus = plusPricing;
        }

        return (
            <div>
                <div className={wrapperClass}>
                    <h1 className={matrixHeaderClass}>Powerful Social Media Automation</h1>
                    <div className="term-toggle">
                        <span className={"monthly" + (this.state.selectedTerm === 1 ? ' active' : '')}>Monthly</span>
                        <ToggleControl
                            {...this.props}
                            noLabel={true}
                            ariaLabel="Bill annually"
                            callback={this.togglePricing}
                            active={(this.state.selectedTerm === 2) ? true : false}/>
                        <span className={"annual" + (this.state.selectedTerm === 2 ? ' active' : '')}>Annual (Save)</span>
                    </div>
                    <Breakpoint desktop only>
                        <div className="pricing-matrix clearfix">
                            <div className="key-column">
                                <ul className="key-list">
                                    {features.map((feature, i) => {
                                        return this.generateFeatureDescription(i, feature);
                                    })}
                                </ul>
                            </div>
                            {plans.map((plan, i) => {
                                return this.generatePlanColumn(i, plan, features);
                            })}
                        </div>
                        {this.generateAgencyBlock()}
                    </Breakpoint>
                    <Breakpoint mobile only>
                        <div className="pricing-matrix mobile">
                            {plans.map((plan, i) => {
                                return this.generatePlanColumn(i, plan, features);
                            })}
                        </div>
                        {this.generateAgencyBlock()}
                    </Breakpoint>
                    <SupportedNetworks {...this.props}/>
                    <div className="plan-fine-print">
                        <p>* X (Twitter) is limited to 150 posts / month per Twitter account. Add additional X Posts at any time.</p>
                    </div>
                    {faqBlock}
                </div>
            </div>
        );
    }

};

PricingMatrix.displayName = "PricingMatrix";

PricingMatrix.propTypes = {
    userPerms: PropTypes.object,
    currentSubscription: PropTypes.object,
    plans: PropTypes.object,
    planDetails: PropTypes.object,
    onPlanUpdate: PropTypes.func,
    context: PropTypes.string,
    trialEligible: PropTypes.bool
};

PricingMatrix.defaultProps = {
    userPerms: {},
    currentSubscription: {},
    plans: {},
    planDetails: {},
    onPlanUpdate: null,
    context: 'upgrade',
    trialEligible: false
};

export default PricingMatrix;
